<template>
  <div class="am-hint-anchor" v-on="$listeners" v-bind="$attrs">
    <span class="am-hint-icon" @click="showDialog">
      <!-- @slot Hint Icon -->
      <slot />
    </span>
    <am-hint-dialog-text :isOpen="isDialogOpen" @close="hideDialog">
      <!-- @slot Hint Title -->
      <template v-slot:title="title">
        <slot name="title" :title="title" />
      </template>
      <!-- @slot Hint Text -->
      <template v-slot:text="text">
        <slot name="text" :text="text" />
      </template>
    </am-hint-dialog-text>
  </div>
</template>

<script>
import AmHintDialogText from "./HintDialogText.vue";

export default {
  inheritAttrs: false,
  data() {
    return {
      isDialogOpen: false
    };
  },
  components: {
    AmHintDialogText
  },
  methods: {
    showDialog() {
      this.isDialogOpen = true;
    },
    hideDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style lang="scss">
.am-hint-anchor {
  display: inline-block;
}
.am-hint-icon {
  cursor: pointer;
}
</style>
